import React, { Fragment, useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { RestHelperNoAuth } from "../helper/restHelperNoAuth";
import mixpanel from "mixpanel-browser";

import { Hero, HomeContent } from "../components";

// Read a cookie value by name (used for the HubSpot `hubspotutk` tracking cookie).
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

// Lightweight US-default E.164 formatter so HubSpot phone data stays consistent.
// NOTE: could be replaced with libphonenumber-js later for full international support.
function toE164(phone) {
    if (!phone) return '';
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;            // US 10-digit
    if (digits.length === 11 && digits[0] === '1') return '+' + digits; // US with country code
    return digits ? '+' + digits : '';                          // best-effort fallback
}

function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

const SignUp = () => {

    const [notary, setNotary] = useState({
        firstName:"",
        lastName:"",
        mobilePhone:"",
        companyName:"",
        address1:"",
        address2:"",
        city:"",
        notaryState:"",
        zip:"",
        laserPrinter:false,
        dualTrayPrinter:false,
        smsOptIn:false,
        certifiedState1:"",
        certifiedState2:"",
        certifiedState3:"",
        certifiedState4:"",
        certifiedState5:"",
        email:"",
        notaryYears:""
    })
    const [editFlag, setEditFlag] = useState(false)
    const [stateList, setStateList] = useState({
        certifiedState1: false,
        certifiedState2: false,
        certifiedState3: false,
        certifiedState4: false,
        certifiedState5: false,
        maxState: false
    })
    const [errorMessage, setErrorMessage] = useState(false)
    const [showForm, setShowForm] = useState(true)
    const [successMessage, setSuccessMessage] = useState(false)
    const [apiResponse, setApiResponse] = useState('')
    const [apiMessage, setApiMessage] = useState('')
    const [apiDetails, setApiDetails] = useState('')
    const [populateStateInfo, setPopulateStateInfo] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    // Inline per-field validation errors for the HubSpot-required fields.
    const [validationErrors, setValidationErrors] = useState({})
    // When true, the form is replaced with the confirmation message.
    const [confirmation, setConfirmation] = useState(false)

    useEffect(() => {
        mixpanel.track('New User Sign Up', {'action' : 'pageview'})
    }, [,])

    const api = RestHelperNoAuth()

    const onChangeEvent = (evt) => {
        const value = evt.target.value;
        setNotary({
            ...notary,
            [evt.target.id]: value
        })
    }

    // Sanitize input to prevent XSS - strips HTML tags and dangerous patterns
    const sanitizeInput = (str) => {
        if (!str) return '';
        return str
            .replace(/<[^>]*>/g, '')           // Remove HTML tags
            .replace(/javascript:/gi, '')       // Remove javascript: protocol
            .replace(/on\w+=/gi, '')            // Remove event handlers like onclick=
            .replace(/[<>]/g, '')               // Remove any remaining < > characters
            .trim();
    }

    // Format name to proper case (first letter uppercase, rest lowercase) and trim spaces
    const toProperCase = (str) => {
        if (!str) return '';
        const sanitized = sanitizeInput(str);
        return sanitized.toLowerCase().replace(/^\w/, c => c.toUpperCase());
    }

    // Format zip to only allow 5 digits and trim spaces
    const formatZip = (str) => {
        if (!str) return '';
        return str.trim().replace(/\D/g, '').slice(0, 5);
    }

    // Handle blur event for name fields - apply proper case
    const onNameBlur = (evt) => {
        const fieldId = evt.target.id;
        const formattedValue = toProperCase(notary[fieldId]);
        setNotary({
            ...notary,
            [fieldId]: formattedValue
        })
    }

    // Handle blur event for zip field - ensure only 5 digits
    const onZipBlur = () => {
        const formattedValue = formatZip(notary.zip);
        setNotary({
            ...notary,
            zip: formattedValue
        })
    }

    // Handle blur event for general text fields - sanitize input
    const onTextBlur = (evt) => {
        const fieldId = evt.target.id;
        const sanitizedValue = sanitizeInput(notary[fieldId]);
        setNotary({
            ...notary,
            [fieldId]: sanitizedValue
        })
    }
    const ref = useRef(null);
    useEffect(() => {
        const stateVar1 = document.getElementById('certifiedState1')
        const idArray = ['certifiedState1','certifiedState2','certifiedState3','certifiedState4','certifiedState5','notaryState']
        const stateArray = ['State', 'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI',
        'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC',
        'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX',
        'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']
        idArray.forEach(value => {
            const stateVar = document.getElementById(value)
            stateArray.forEach(value2 => {
                const option = document.createElement('option')
                option.innerHTML = value2
                if (notary[value] == value2) {
                    option.setAttribute('selected','selected')
                }
                stateVar.appendChild(option)
            })
        })
    },[populateStateInfo,setPopulateStateInfo]);
    //const stateVar = document.getElementById('certifiedState1Select')

    const onToggle = (evt) => {
        const key = evt.target.id
        const value = notary[key]
        if (value) {
            setNotary({
                ...notary,
                [evt.target.id] : false
            })
        }
        else {
            setNotary({
                ...notary,
                [evt.target.id] : true
            })
        }
    }

    const clearErrorMessage = () => {
        setErrorMessage(false)
        setShowForm(true)
        setPopulateStateInfo(!populateStateInfo)
    }

    const addState = (evt) => {
        const value = evt.target.id
        setNotary({
            ...notary,
            [value] : evt.target.value
        })
    }

    // Validate the HubSpot-required fields client-side. Returns a map of
    // field -> error message (empty object means valid).
    const validateForm = () => {
        const errors = {}
        if (!notary.firstName || !notary.firstName.trim()) errors.firstName = 'First name is required'
        if (!notary.lastName || !notary.lastName.trim()) errors.lastName = 'Last name is required'
        if (!notary.email || !notary.email.trim()) errors.email = 'Email is required'
        else if (!isValidEmail(notary.email.trim())) errors.email = 'Enter a valid email address'
        if (!notary.mobilePhone || !notary.mobilePhone.trim()) errors.mobilePhone = 'Phone number is required'
        return errors
    }

    // Build the HubSpot submission payload, mapping the form's field names to
    // the HubSpot form definition and omitting empty optional fields.
    const buildPayload = () => {
        const fields = {
            firstname: notary.firstName.trim(),
            lastname: notary.lastName.trim(),
            email: notary.email.trim(),
            phone: toE164(notary.mobilePhone),
        }
        if (notary.city && notary.city.trim()) fields.city = notary.city.trim()
        if (notary.notaryState && notary.notaryState.trim() && notary.notaryState !== 'State') {
            fields.state = notary.notaryState.trim().toUpperCase().slice(0, 2)
        }
        if (notary.zip && notary.zip.trim()) fields.zip = notary.zip.trim()

        const payload = {
            formType: 'notary',
            fields,
            pageUri: window.location.href,
            pageName: document.title,
        }
        const hutk = getCookie('hubspotutk')
        if (hutk) payload.hutk = hutk
        return payload
    }

    const callApi = () => {
        setIsLoading(true)
        setShowForm(false)
        api
        .postWithStatus('/forms/submit', buildPayload())
        .then(res => {
            setIsLoading(false)
            if (res.status === 200) {
                // Success.
                setConfirmation(true)
            } else if (res.status >= 400 && res.status < 500) {
                // Caller error (bad data / schema). Keep the form so the user can correct.
                setShowForm(true)
                setErrorMessage(true)
                setApiResponse('We could not submit your application.')
                setApiMessage('Please review your information and try again.')
                setApiDetails('')
            } else {
                // 5xx or network failure (status 0): the backend fallback email
                // captures the lead, so show the same confirmation as success.
                setConfirmation(true)
            }
        })
        .catch(err => {
            // postWithStatus does not reject, but guard anyway: treat as captured.
            console.log(err)
            setIsLoading(false)
            setConfirmation(true)
        })
    }


    const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const errors = validateForm()
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors)
            return
        }
        setValidationErrors({})
        mixpanel.track('New User Sign Up', {'action' : 'signup'})
        callApi()
    }

    return (
        <Fragment>
            {confirmation && (
                <div className="max-w-5xl mx-auto px-4 mt-4 mb-4">
                    <div className="card">
                        <div className="card-body rounded-lg border border-neutral-200 bg-white text-center py-8">
                            <h5 className="font-semibold text-xl">
                                Thanks for applying. We'll review your application and follow up within two business days.
                            </h5>
                        </div>
                    </div>
                </div>
            )}
            {errorMessage && (
                <div className="max-w-5xl mx-auto px-4 border border-neutral-200 rounded-lg">
                <div className="flex flex-wrap rounded-lg bg-white">
                 <button className="ml-3 mb-2 mt-2 text-2xl font-bold text-neutral-500 hover:text-neutral-700" aria-label="Close" onClick={() =>clearErrorMessage()}>
                  <span aria-hidden='false'>&times;</span>
                 </button>
                </div>
                <div className="card mb-3 mt-3">
                    <div className="card-body rounded-lg bg-white">
                        <h5 className="font-semibold text-lg mb-2">Registration Status</h5>
                        <h6 className="text-base text-neutral-600 mb-2">{ apiResponse }</h6>
                        <h6 className="text-base text-neutral-600 mb-2">{ apiMessage }</h6>
                        <h5 className="font-semibold text-lg mb-2">{ apiDetails }</h5>
                    </div>
              </div>
              </div>
            )}
            {showForm && (
            <div className="max-w-5xl mx-auto px-4 rounded-lg border border-neutral-200 bg-white mt-4 mb-4" id="myInput">
             <div className="flex flex-wrap -mx-2 mx-3 mt-3">
                <div className="flex-1 px-2">
                <p className="text-lg text-center">
                    Join Us!
                </p>
                </div>
                <div className="flex-1 px-2">
                <p className="text-lg text-center">
                    Get notified of assignments in your area!
                </p>
                </div>
                <div className="flex-1 px-2">
                <p className="text-lg text-center">
                    Register below!
                </p>
                </div>
            </div>
            <div>
            {/* Bot protection (deferred, spec §10): add a honeypot field or
                Cloudflare Turnstile widget here and include its token in buildPayload(). */}
            <form onSubmit={onSubmitHandler}>
             <div className="card mb-3 mt-3">
             <div className="card-body rounded-lg border border-neutral-200 bg-neutral-100">
              <h5 className="font-semibold text-lg mb-2">Contact Info</h5>
              <h6 className="text-sm text-neutral-500 mb-2">Please complete basic contact info for registration</h6>
              <div className="flex flex-wrap -mx-2">
               <div className="flex-1 px-2 mb-3 mt-2">
                <label htmlFor="appt_name" className="form-label">First Name</label>
                {editFlag
                ? <input className="form-input" id="firstName" onChange={(e)=>onChangeEvent(e)} onBlur={(e)=>onNameBlur(e)} type="text" value={notary.firstName} required readOnly/>
                : <input className="form-input" id="firstName" onChange={(e)=>onChangeEvent(e)} onBlur={(e)=>onNameBlur(e)} type="text" value={notary.firstName} required/>}
                {validationErrors.firstName && <p className="text-sm text-red-600 mt-1">{validationErrors.firstName}</p>}
               </div>
               <div className="flex-1 px-2 mb-3 mt-2">
                <label htmlFor="appt_name" className="form-label">Last Name</label>
                <input className="form-input" id="lastName" onChange={(e)=>onChangeEvent(e)} onBlur={(e)=>onNameBlur(e)} type="text" value={notary.lastName} required/>
                {validationErrors.lastName && <p className="text-sm text-red-600 mt-1">{validationErrors.lastName}</p>}
               </div>
              </div>
              <div className="flex flex-wrap -mx-2">
               <div className="flex-1 px-2 mb-3 mt-2">
                <label htmlFor="city" className="form-label">City</label>
                <input className="form-input" id="city" onChange={(e)=>onChangeEvent(e)} onBlur={(e)=>onTextBlur(e)} type="text" value={notary.city}/>
               </div>
              </div>
              <div className="flex flex-wrap -mx-2">
               <div className="flex-1 px-2 mb-3 mt-2">
               <label htmlFor="notaryState" className="form-label">State</label>
                  <select className="form-input text-sm mb-3" aria-label="form-select-sm" id="notaryState" onChange={(e)=>addState(e)}></select>
               </div>
               <div className="flex-1 px-2 mb-3 mt-2">
                <label htmlFor="zip" className="form-label">Zip Code</label>
                <input className="form-input" id="zip" maxLength="5" onChange={(e)=>onChangeEvent(e)} onBlur={onZipBlur} type="tel" value={notary.zip}/>
               </div>
              </div>
              <div className="mb-3 mt-2">
               <label htmlFor="appt_name" className="form-label">Email Address</label>
               <input className="form-input" id="email" onChange={(e)=>onChangeEvent(e)} onBlur={(e)=>onTextBlur(e)} type="email" value={notary.email} required/>
               {validationErrors.email && <p className="text-sm text-red-600 mt-1">{validationErrors.email}</p>}
              </div>
              <div className="mb-3 mt-2">
               <label htmlFor="appt_name" className="form-label">Mobile Phone Number</label>
               <input className="form-input" id="mobilePhone" onChange={(e)=>onChangeEvent(e)} type="tel" value={notary.mobilePhone} required/>
               {validationErrors.mobilePhone && <p className="text-sm text-red-600 mt-1">{validationErrors.mobilePhone}</p>}
              </div>
              <div className="flex items-center justify-end">
               <input className="w-4 h-4 text-sky-500 border-neutral-300 rounded focus:ring-sky-500" id="smsOptIn" onChange={(e)=>onToggle(e)} type="checkbox" value={notary.smsOptIn}/>
               <label htmlFor="smsOptIn" className="ml-2 text-sm text-neutral-700">Opt in to receive notifications via SMS to this number</label>
              </div>
              </div>
              </div>
              <div className="card mb-3 mt-3">
               <div className="card-body rounded-lg border border-neutral-200 bg-neutral-100">
                <h5 className="font-semibold text-lg mb-2">Signing Agent / Field Inspector Details</h5>
                <h6 className="text-sm text-neutral-500 mb-2">Please provide additional information to help us match you with the best assignments.</h6>
                <div className="mb-3 mt-2">
                 <label htmlFor="notaryYears" className="form-label">Years of experience</label>
                 <input className="form-input" id="notaryYears" onChange={(e)=>onChangeEvent(e)} type="tel" value={notary.notaryYears}/>
                </div>
                <div className="mb-3 mt-2">
                 <label htmlFor="companyName" className="form-label">Company Name</label>
                 <input className="form-input" id="companyName" onChange={(e)=>onChangeEvent(e)} onBlur={(e)=>onTextBlur(e)} type="text" value={notary.companyName}/>
                </div>
                <h5 className="font-semibold text-lg mb-3">Please identify up to five states in which you are certified:</h5>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="md:col-span-1">
                  <label htmlFor="certifiedState1" className="form-label">First State</label>
                  <select className="form-input text-sm mb-3" aria-label="form-select-sm" id="certifiedState1" onChange={(e)=>addState(e)}></select>
                </div>
                <div className="md:col-span-1">
                  <label htmlFor="certifiedState2" className="form-label">Second State</label>
                  <select className="form-input text-sm mb-3" aria-label="form-select-sm" id="certifiedState2" onChange={(e)=>addState(e)}></select>
                </div>
                <div className="md:col-span-1">
                  <label htmlFor="certifiedState3" className="form-label">Third State</label>
                  <select className="form-input text-sm mb-3" aria-label="form-select-sm" id="certifiedState3" onChange={(e)=>addState(e)}></select>
                </div>
                <div className="md:col-span-1">
                  <label htmlFor="certifiedState4" className="form-label">Fourth State</label>
                  <select className="form-input text-sm mb-3" aria-label="form-select-sm" id="certifiedState4" onChange={(e)=>addState(e)}></select>
                </div>
                <div className="md:col-span-1">
                  <label htmlFor="certifiedState5" className="form-label">Fifth State</label>
                  <select className="form-input text-sm mb-3" aria-label="form-select-sm" id="certifiedState5" onChange={(e)=>addState(e)}></select>
                </div>
                </div>
                <div className="flex items-center justify-end">
                 <input className="w-4 h-4 text-sky-500 border-neutral-300 rounded focus:ring-sky-500" id="laserPrinter" onChange={(e)=>onToggle(e)} type="checkbox" value={notary.laserPrinter}/>
                 <label htmlFor="laserPrinter" className="ml-2 text-sm text-neutral-700">Laser Printer</label>
                </div>
                <div className="flex items-center justify-end">
                 <input className="w-4 h-4 text-sky-500 border-neutral-300 rounded focus:ring-sky-500" id="dualTrayPrinter" onChange={(e)=>onToggle(e)} type="checkbox" value={notary.dualTrayPrinter}/>
                 <label htmlFor="dualTrayPrinter" className="ml-2 text-sm text-neutral-700">Dual Tray Printer</label>
                </div>
               </div>

             </div>
             <input className="btn btn-secondary rounded-lg mb-3" type="submit" value="Register"/>
            </form>
            </div>
            </div>
            )}
            {isLoading &&
                (<div className="flex justify-center mb-4 mt-4">
                    <div className="spinner-icon" role="status">
                        <span className="sr-only"></span>
                    </div>
                </div>)}
        </Fragment>
    )
   };

export default SignUp;
